<template>
  <v-form ref="frmMainClone" v-model="valid" lazy-validation>
    <v-card class="cloneDialog" :loading="loading" :disabled="loading">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6" sm="6">
            <label class="input-label"> Date <small class="mt-6 error--text">*</small> </label>
            <v-date-input
              :min="minDate"
              first-day-of-week="1"
              :rules="[rules.required]"
              v-model="timesheetModel.date"
              hide-actions
              placeholder="Date"
              prepend-icon=""
            />
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <NumberField
              :rules="[rules.required, rules.step, rules.notZero]"
              min="0"
              max="10"
              label="Effort / Hours"
              placeholder="Effort / Hours"
              v-model="timesheetModel.effort"
              outlined
              step="0.25"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="action-bottons">
        <div class="d-flex flex-wrap flex-column flex-md-row-reverse ml-auto mr-auto mr-md-1 ga-3">
          <v-btn class="tertiary_btn right actionButton" @click="confirm(true)"> <v-icon>mdi-check</v-icon>Save and Edit </v-btn>
          <v-btn class="primary_btn right actionButton" @click="confirm"> <v-icon>mdi-check</v-icon>Save </v-btn>
          <v-btn text class="secondary_btn right actionButton" @click="cancel"><v-icon>mdi-close</v-icon>Cancel</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script lang="ts">
import Vue, { defineComponent } from "vue";
import LoadingComponent from "shared-components/src/components/Loading.vue";
import Timesheet from "../../models/Timesheet";
import Utils from "../../utils/Utils";
import TextField from "../Fields/TextField.vue";
import AppHelper from "../../utils/AppHelper";

export default defineComponent({
  components: {
    LoadingComponent,
    TextField,
  },
  props: ["isAdmin", "timesheetInfo"],
  data() {
    return {
      loading: false,
      valid: false,
      menu: false,
      timesheetModel: {
        date: AppHelper.IsAzureEnv()
          ? this.timesheetInfo.Date
          : this.timesheetInfo.Date
          ? Utils.vsDateToDatetime(this.timesheetInfo.date)
          : (null as Date | null),
        effort: this.timesheetInfo.Effort,
      },
      rules: {
        required: (value: any) => !!value || "Required.",
        step: (value: any) => value % 0.25 == 0 || "Please enter a value multiple of 0.25",
        notZero: (value: any) => value > 0 || "Please enter a value more than 0",
      },
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel", this.timesheetModel.date);
    },
    resetHours(value: any) {
      value.setHours(0, 0, 0, 0);
      return value;
    },
    async confirm(goToEdit = false) {
      const isValid = (await (this.$refs.frmMainClone as any).validate()).valid;
      if (isValid) {
        if (this.isLessThanSixDays(this.timesheetModel.date)) {
          this.loading = true;
          if (this.timesheetModel.effort < 0) {
            this.timesheetModel.effort = 0;
          }
          const timesheet = this.timesheetInfo as Timesheet;
          timesheet.Date = this.timesheetModel.date;
          timesheet.Effort = this.timesheetModel.effort;
          timesheet.Adjustment = 0;
          timesheet.id = "";
          await this.$emit("confirmClone", { timesheet: timesheet, goToEdit });
        } else {
          this.$emit("showErrorMessage", "You can't add timesheet less than 6 days from today!");
        }
      }
    },
    isLessThanSixDays(date: any) {
      if (this.isAdmin) {
        return true;
      }
      const clickedDay = new Date(date);
      const today = new Date();
      today.setDate(today.getDate() - 7);
      return today < clickedDay;
    },
    checkDate(): boolean {
      if (this.timesheetInfo.Date) {
        const dt = Utils.vsDateToDatetime(this.timesheetInfo.date);
        dt.setHours(0);
        dt.setMinutes(0);
        dt.setSeconds(0);
        dt.setMilliseconds(0);
        return dt >= this.dateLimit;
      }
      return true;
    },
  },
  computed: {
    dateLimit(): Date {
      return Utils.GetLimitedDateForTimesheet(this.isAdmin);
    },
    minDate(): string {
      return Utils.toVsDateFormat(this.dateLimit);
    },
    formatedSelectedDate() {
      if (this.timesheetModel.date && this.timesheetModel.date < this.dateLimit) this.timesheetModel.date = this.dateLimit;
      return Utils.toVsDateFormat(this.timesheetModel.date || new Date());
    },
  },
  mounted() {
    this.timesheetModel.date = this.timesheetInfo.Date;
  },
});
</script>
<style lang="scss">
.cloneDialog {
  overflow: hidden !important;
}
</style>
